import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalProps,
} from '@chakra-ui/react';
import { themeVariables } from '@meteraprotocol/sdk/ui/theme.js';
import emotionStyled from '@emotion/styled';
const styled = (emotionStyled as any).default || emotionStyled; // Fallback to named import

const StyledModalContent = styled(ModalContent)`
  @property --animated-border {
    syntax: '<angle>';
    inherits: true;
    initial-value: 0turn;
  }
`;

export const LoadingModal = ({
  children,
  minHeight = '15rem',
  minWidth = '50%',
  ...rest
}: ModalProps & { minWidth?: string; minHeight?: string }) => (
  <Modal isCentered {...rest}>
    <ModalOverlay bg="#171717B3" />
    <StyledModalContent
      background={themeVariables.cards.background}
      minHeight={minHeight}
      minWidth={minWidth}
      padding="0rem"
      borderRadius={'1.25rem'}
      border={`1px solid ${themeVariables.cards.stroke}`}
      sx={{
        cursor: 'pointer',
        border: '2px solid transparent',
        transition: 'border 0.2s, transform 0.2s',
        borderRadius: '10px !important',
        '--animated-border': themeVariables.animatedBorder.initialValue,
        background: `
            conic-gradient(
              from var(--animated-border),
              #171717a3,
              #171717a3 5%,
              #171717a3 60%,
              #171717a3 95%
            )
            padding-box,
            conic-gradient(
              from var(--animated-border),
              transparent 25%,
              #6d28d9,
              #a78bfa 99%,
              transparent
            )
            border-box`,
        animation: `${themeVariables.animatedBorder.bgSpin} 3s linear infinite`,
      }}
    >
      <ModalBody padding={0}>{children}</ModalBody>
    </StyledModalContent>
  </Modal>
);
